import { useEffect } from "react"
import { motion, useMotionValue, animate, useTransform } from "framer-motion"
import { ArrowUp, ArrowDown } from "lucide-react"
import Icon from "../../../components/AppIcon"

// Colored arrow + percentage, matching the reference dashboard's trend style
// (small icon, tinted text, plain — not a filled pill badge).
const TrendRow = ({ value, sub }) => {
  if (value === null || value === undefined) {
    return sub ? <span className="text-xs text-muted-foreground">{sub}</span> : null
  }
  const isPositive = value >= 0
  const TrendIcon = isPositive ? ArrowUp : ArrowDown
  return (
    <div className="flex items-center gap-1.5 text-xs">
      <span className={`flex items-center gap-0.5 font-medium ${isPositive ? "text-emerald-600" : "text-rose-600"}`}>
        <TrendIcon size={12} strokeWidth={2.5} />
        {Math.abs(value)}%
      </span>
      {sub && <span className="text-muted-foreground">{sub}</span>}
    </div>
  )
}

const KPICard = ({ label, rawValue = 0, formatValue = (v) => v, sub, change, icon, onClick }) => {
  const count = useMotionValue(0)
  const displayValue = useTransform(count, (v) => formatValue(v))

  useEffect(() => {
    const controls = animate(count, rawValue, { duration: 1, ease: "easeOut" })
    return controls.stop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawValue])

  return (
    <motion.button
      onClick={onClick}
      whileHover={{ y: -3 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      className="text-left w-full h-full min-h-[136px] p-5 rounded-2xl bg-foreground/[0.02] border border-foreground/[0.06] hover:bg-foreground/[0.04] hover:border-foreground/[0.12] transition-colors flex flex-col justify-between"
    >
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{label}</span>
        <Icon name={icon} size={16} className="text-muted-foreground/70" />
      </div>
      <div>
        <motion.div className="text-3xl font-semibold tracking-tight text-foreground mb-2">{displayValue}</motion.div>
        <TrendRow value={change} sub={sub} />
      </div>
    </motion.button>
  )
}

export default KPICard